export default __webpack_public_path__ + "static/scams-hub-step-up-your-security-hero-3a89088f45f146c95535c52fca3c7611.webp";